var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0036 1.22934L6.73624 5.82656L1.66332 6.56614C0.753597 6.69809 0.389014 7.81961 1.04874 8.46198L4.71887 12.0384L3.85082 17.0904C3.69457 18.0036 4.65638 18.6877 5.46193 18.2606L10.0001 15.8752L14.5383 18.2606C15.3439 18.6842 16.3057 18.0036 16.1494 17.0904L15.2814 12.0384L18.9515 8.46198C19.6112 7.81961 19.2467 6.69809 18.3369 6.56614L13.264 5.82656L10.9967 1.22934C10.5904 0.409891 9.41332 0.399474 9.0036 1.22934Z",
    fill: "#0D8847"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullStarIcon);
export default __webpack_public_path__ + "static/media/fullStarIcon.771a6bb16099b772f61d84d37bbc9f26.svg";
export { ForwardRef as ReactComponent };